import client from './client';

export const getUsers = (params) => client.get('/users', { params });

export const getUserDetail = (id) => client.get(`/users/${id}`);

export const banUser = (id, data) => client.post(`/users/${id}/ban`, data);

export const unbanUser = (id) => client.post(`/users/${id}/unban`);
